export default __webpack_public_path__ + "IT_goal.png";